import React from "react";
const IconStoreLocator = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M12.798 14.455A23.728 23.728 0 0 1 10 17a23.725 23.725 0 0 1-2.798-2.545C5.192 12.3 4 10.129 4 8.137 4 4.662 6.56 2 10 2s6 2.663 6 6.137c0 1.992-1.191 4.162-3.202 6.318Z"
    />
    <circle cx="10" cy="8" r="2" fill="currentColor" />
  </svg>
);
export default IconStoreLocator;
